import { Status } from '@/shared/types/Status';

export const CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.uploading]: 'Uploading',
  [Status.uploaded]: 'Uploading',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.transcriptionStarted]: 'Transcripting video',
  [Status.transcriptionDone]: 'Transcripting video',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceSuggestDone]: 'Analyzing voices',
  [Status.translationStarted]: 'Translating text',
  [Status.translationDone]: 'Ready to generate video',
  [Status.transcriptEdited]: 'Ready to generate video',
  [Status.voiceEdited]: 'Ready to generate video',
  [Status.voiceUpdateStarted]: 'Voices analyzing',
  [Status.voiceUpdateDone]: 'Ready to generate video',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.mergingStarted]: 'Generating video',
  [Status.mergingDone]: 'Video is generated',
  [Status.failed]: 'Error',
  [Status.uploadFailed]: 'Upload failed',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.voiceSuggestFailed]: 'Analyzing voices',
  [Status.translationFailed]: 'Translation failed',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.mergingFailed]: 'Merging failed',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.noAudio]: 'Video has no sound',
  [Status.noWords]: 'Video lacks speech',
  [Status.forbiddenLink]: 'Forbidden link',
} as const;

export const DST_SRT_UPLOADED_CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.uploading]: 'Uploading',
  [Status.uploaded]: 'Uploading',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceSuggestDone]: 'Ready to generate video',
  [Status.transcriptEdited]: 'Ready to generate video',
  [Status.voiceEdited]: 'Ready to generate video',
  [Status.voiceUpdateStarted]: 'Analyzing voices',
  [Status.voiceUpdateDone]: 'Ready to generate video',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.mergingStarted]: 'Generating video',
  [Status.mergingDone]: 'Video is generated',
  [Status.failed]: 'Error',
  [Status.uploadFailed]: 'Upload failed',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.voiceSuggestFailed]: 'Ready to generate video',
  [Status.translationFailed]: 'Translation failed',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.mergingFailed]: 'Merging failed',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.noAudio]: 'No audio',
  [Status.noWords]: 'No words',
  [Status.forbiddenLink]: 'Forbidden link',
} as const;

export const AUTOGENERATION_CHIP_LABEL = {
  [Status.created]: 'Uploading',
  [Status.uploading]: 'Uploading',
  [Status.uploaded]: 'Uploading',
  [Status.separateBackgroundStarted]: 'Analyzing video',
  [Status.separateBackgroundDone]: 'Analyzing video',
  [Status.transcribeSegmentsStarted]: 'Analyzing SRT',
  [Status.transcribeSegmentsDone]: 'Analyzing SRT',
  [Status.determineSpeakersStarted]: 'Analyzing speakers',
  [Status.determineSpeakersDone]: 'Analyzing speakers',
  [Status.transcriptionStarted]: 'Transcripting video',
  [Status.transcriptionDone]: 'Transcripting video',
  [Status.voiceSuggestStarted]: 'Analyzing voices',
  [Status.voiceSuggestDone]: 'Analyzing voices',
  [Status.translationStarted]: 'Translating text',
  [Status.translationDone]: 'Translating text',
  [Status.transcriptEdited]: 'Generating video',
  [Status.voiceEdited]: 'Generating video',
  [Status.voiceUpdateStarted]: 'Generating video',
  [Status.voiceUpdateDone]: 'Generating video',
  [Status.voiceoverStarted]: 'Generating video',
  [Status.voiceoverDone]: 'Generating video',
  [Status.mergingStarted]: 'Generating video',
  [Status.mergingDone]: 'Video is generated',
  [Status.failed]: 'Error',
  [Status.uploadFailed]: 'Upload failed',
  [Status.transcriptionFailed]: 'Transcription failed',
  [Status.voiceSuggestFailed]: 'Analyzing voices',
  [Status.translationFailed]: 'Translation failed',
  [Status.voiceoverFailed]: 'Voiceover failed',
  [Status.mergingFailed]: 'Merging failed',
  [Status.voiceUpdateFailed]: 'Ready to generate video',
  [Status.separateBackgroundFailed]: 'Separate background failed',
  [Status.transcribeSegmentsFailed]: 'Transcribe segments failed',
  [Status.determineSpeakersFailed]: 'Determine speakers failed',
  [Status.noAudio]: 'No audio',
  [Status.noWords]: 'No words',
  [Status.forbiddenLink]: 'Forbidden link',
} as const;
